<app-side-menu class="side-menu" (toggle)="toggleCollapse($event)"></app-side-menu>

<head>
  <link rel="stylesheet" href="dashboard.component.css">
</head>

<div class="layout-wrapper">

<body class="green lighten-5">
  <div class="navbar" [class.admin-expanded]="isNavbarExpanded">
    <app-navbar></app-navbar>
  </div>

  <div class="main-panel" [class.admin-expanded]="isNavbarExpanded">
    <h2 class="pagetitle">
      -
    </h2>
    

    <div class="row-container">
      <div class="approved-card">
        <div class="card-grid">
          <div class="card-left">
            <h6 class="status-text">Approved</h6>
            <h4 class="status-count">{{ activeSystemCount }}</h4>
          </div>
          <div class="card-right">
            <i class="medium material-icons status-icon">trending_up</i>
          </div>
        </div>
      </div>
  
      <div class="declined-card">
        <div class="card-grid">
          <div class="card-left">
            <h6 class="status-text">Declined</h6>
            <h4 class="status-count">{{ inactiveSystemCount }}</h4>
          </div>
          <div class="card-right">
            <i class="medium material-icons status-icon">trending_down</i>
          </div>
        </div>
      </div>
  
      <div class="under-review-card">
        <div class="card-grid">
          <div class="card-left">
            <h6 class="status-text">Under Review</h6>
            <h4 class="status-count">{{ underReviewCount }}</h4>
          </div>
          <div class="card-right">
            <i class="medium material-icons status-icon">schedule</i>
          </div>
        </div>
      </div>

      <div class="vendor-action-card">
        <div class="card-grid">
          <div class="card-left">
            <h6 class="status-text">Action Required</h6>
            <h4 class="status-count">{{ vendorActionRequiredCount }}</h4>
          </div>
          <div class="card-right">
            <i class="medium material-icons status-icon">notification_important</i>
          </div>
        </div>
      </div>
    </div>
  
    <!-- <div class="scroll-container-wrapper"> -->
      <!-- <div class="scroll-container"> -->

        <div>
          <!-- FLAGGED -->
          <!-- <div *ngIf="flaggedaccounts?.length > 0;" class="section-card" style="margin-bottom: 20px; height: 200px;">
            <div class="scrollable-content" >
              <div class="request-card" *ngFor="let account of flaggedaccounts">
                <img src="/assets/gray-photo-placeholder-icon-design-ui-vector-35850819.jpg" class="avatar" />
                <div class="request-info">
                  <h5>{{ account.company.strCompanyName }}</h5>
                  <p>{{ account.strName }}, {{ account.strEmail }}</p>
                  <p class="date-text">{{ formatSubmissionDate(account.company.dteRegistration) }}</p>
                </div>
                <div class="request-actions">
                  <button (click)="openViewForm(account.intUserPK)" class="btn-primary">View Full <i class="material-icons tiny">call_made</i></button>
                  <button *ngIf="account?.blnFlagged == false"  (click)="flagForFollowUp(account)" class="btn-secondary">Flag <i class="material-icons tiny">turned_in_not</i></button>
                  <button *ngIf="account?.blnFlagged == true" (click)="unflagAccount(account)" class="btn-secondary">Unflag <i class="material-icons tiny">turned_in</i></button>
                </div>
              </div>
            </div>
          </div> -->

          <!-- PENDING REQUESTS -->
          <div class="section-card">
            <span class="container-count-badge badge-under-review">{{ pendingaccounts?.length || 0 }}</span>
            <h4 class="section-title">Pending Requests</h4>
            <h6 class="help-text">
              <i class="tiny material-icons icon-inline">help_outline</i> Review and respond to these requests
            </h6>
            <div *ngIf="loadingStates.pending" class="spinner-wrapper">
              <div class="spinner"></div>
            </div>

            <div class="scrollable-content" *ngIf="pendingaccounts?.length > 0; else noPending">
              <div class="request-card" *ngFor="let account of pendingaccounts">
                <img src="/assets/gray-photo-placeholder-icon-design-ui-vector-35850819.jpg" class="avatar" />
                <div class="request-info">
                  <h5>{{ account.company.strCompanyName }}</h5>
                  <p>{{ account.strName }}, {{ account.strEmail }}</p>
                  <p class="date-text">{{ formatSubmissionDate(account.company.dteRegistration) }}</p>
                </div>
                <div class="request-actions">
                  <button (click)="openViewForm(account.intUserPK)" class="btn-primary">View Full <i class="material-icons tiny">call_made</i></button>
                  <button
                    *ngIf="!account.blnFlagged"
                    (click)="flagForFollowUp(account)"
                    class="btn-secondary flag-action-btn"
                    [disabled]="isFlagUpdating(account)"
                    [attr.aria-busy]="isFlagUpdating(account)"
                    title="Flag for follow-up">
                    <span *ngIf="isFlagUpdating(account); else flagLabel" class="flag-btn-spinner" aria-hidden="true"></span>
                    <ng-template #flagLabel>Flag <i class="material-icons tiny">turned_in_not</i></ng-template>
                  </button>
                  <button
                    *ngIf="account.blnFlagged"
                    (click)="unflagAccount(account)"
                    class="btn-secondary flag-action-btn"
                    [disabled]="isFlagUpdating(account)"
                    [attr.aria-busy]="isFlagUpdating(account)"
                    title="Remove flag">
                    <span *ngIf="isFlagUpdating(account); else unflagLabel" class="flag-btn-spinner" aria-hidden="true"></span>
                    <ng-template #unflagLabel>Unflag <i class="material-icons tiny">turned_in</i></ng-template>
                  </button>
                </div>
              </div>
            </div>
            <ng-template #noPending>
              <p *ngIf="!loadingStates.pending" class="empty-placeholder">No pending requests.</p>
            </ng-template>
          </div>

          <!-- APPROVED & DECLINES in a row -->
          <div class="approved-declined-wrapper">
            <!-- APPROVED REQUESTS -->
            <div class="section-card approved-section">
              <span class="container-count-badge badge-approved">{{ acceptedaccounts?.length || 0 }}</span>
              <h4 class="section-title">Recently Approved</h4>

              <div *ngIf="loadingStates.approved" class="spinner-wrapper">
                <div class="spinner"></div>
              </div>

              <div class="scrollable-content" *ngIf="acceptedaccounts?.length > 0; else noAccepted">
                <div class="request-card simple-card" *ngFor="let account of acceptedaccounts">
                  <div class="request-info">
                    <h5>{{ account.company.strCompanyName }}</h5>
                    <p>{{ account.strName }}, {{ account.strEmail }}</p>
                  </div>
                  <div class="request-actions">
                    <button (click)="openViewForm(account.intUserPK)" class="btn-primary">View Full <i class="material-icons tiny">call_made</i></button>
                  </div>
                </div>
              </div>
              <ng-template #noAccepted>
                <p *ngIf="!loadingStates.approved" class="empty-placeholder">No approved requests.</p>
              </ng-template>
            </div>

            <!-- REJECTED REQUESTS -->
            <div class="section-card declined-section">
              <span class="container-count-badge badge-declined">{{ rejectedaccounts?.length || 0 }}</span>
              <h4 class="section-title">Recently Declined</h4>
              
              <div *ngIf="loadingStates.declined" class="spinner-wrapper">
                <div class="spinner"></div>
              </div>

              <div class="scrollable-content" *ngIf="rejectedaccounts?.length > 0; else noRejected">
                <div class="request-card simple-card" *ngFor="let account of rejectedaccounts">
                  <div class="request-info">
                    <h5>{{ account.company.strCompanyName }}</h5>
                    <p>{{ account.strName }}, {{ account.strEmail }}</p>
                  </div>
                  <div class="request-actions">
                    <button (click)="openViewForm(account.intUserPK)" class="btn-view">View Full <i class="material-icons tiny">call_made</i></button>
                  </div>
                </div>
              </div>
              <ng-template #noRejected>
                <p *ngIf="!loadingStates.declined" class="empty-placeholder">No declined requests.</p>
              </ng-template>
            </div>
          </div> <!-- end approved-declined-wrapper -->
        </div> <!-- end card -->

      <!-- </div> end scroll-container -->
    <!-- </div> end scroll-container-wrapper -->
  </div> <!-- end main-panel -->
</body>

<router-outlet></router-outlet>
</div>
